import { Attribute } from '@/common/attribute';
import { SupportedLocale } from '@/hoslog-intl/Translation';
import {
  CLUB_VERIFICATION_STATUS,
  PAYMENT_METHOD,
  PAYMENT_STATUS,
  ReservationLedger,
} from '@/services/dashboard/reservationLedger/reservationLedger.types';

type Translate = (key: string) => string;

export function getClubVerificationStatusLabel(status: ReservationLedger['clubVerificationStatus'], t: Translate) {
  if (status === CLUB_VERIFICATION_STATUS.PENDING) return t('common.page.table.pending');
  if (status === CLUB_VERIFICATION_STATUS.APPROVED) return t('common.page.table.approved');
  return t('common.page.table.rejected');
}

export function getPaymentStatusLabel(status: ReservationLedger['paymentStatus'], t: Translate) {
  if (status === PAYMENT_STATUS.PENDING) return t('common.page.table.pending');
  if (status === PAYMENT_STATUS.SUCCESS) return t('common.page.table.success');
  return t('common.page.table.canceled');
}

export function getPlanTypeLabel(
  planType: string | undefined | null,
  reservationPlanTypes: Attribute[],
  locale: SupportedLocale,
): string {
  if (!planType) return '-';

  const normalizedPlanType = String(planType).trim().toLowerCase();
  const matched = reservationPlanTypes.find(
    (val) =>
      val.value === String(planType) ||
      val.labelEng?.trim().toLowerCase() === normalizedPlanType ||
      val.label?.trim().toLowerCase() === normalizedPlanType ||
      val.labelEng === String(planType) ||
      val.label === String(planType),
  );

  if (!matched) return '-';
  return locale === 'en' ? matched.labelEng : matched.label || matched.labelEng;
}

export function getPaymentMethodLabel(paymentMethod: string | undefined | null, t: Translate) {
  if (paymentMethod === PAYMENT_METHOD.HOSLOG_POINTS || paymentMethod === 'Hoslog Points') {
    return t('common.page.table.hoslogPoints');
  }

  if (paymentMethod === PAYMENT_METHOD.ONSITE || paymentMethod === 'On site payment') {
    return t('common.page.table.onSitePayment');
  }

  return '-';
}
